<template>
    <div class="top-bar-item" @click="handleClick">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "TopBarItem",
        data: function () {
            return {}
        },
        methods: {
            handleClick() {
                this.$emit("press");
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../../styles/global";

.top-bar-item {
    display: block;
    width: 100%;
    height: 100%;
    cursor: pointer;
    padding: 4px 15px 4px 15px;
    min-width: 150px;
}
.top-bar-item:hover {
    cursor: pointer;
    background-color: darken($navigationGray, 5);
}
</style>